import { render, staticRenderFns } from "./StructControlList.vue?vue&type=template&id=586b3bc0&scoped=true&"
import script from "./StructControlList.vue?vue&type=script&lang=js&"
export * from "./StructControlList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "586b3bc0",
  null
  
)

export default component.exports